import { get, post, postFd, download } from "@utils/axios";

const api = "company/employees";
const apiTimeZones = "common/getTimezones"
const apiSalutations = "common/getSalutations"
export const getEmployeesReq = (payload) => {
  if (!payload.showActive && payload.showActive !== undefined) {
    payload.filters = `${payload.filters};trashed_type_|onlyTrashed`;
  } else {
    //remove trashed_type
    payload.filters = payload.filters.replace(/;trashed_type_\|onlyTrashed/, '');
  }
  return get(`company/employee/employments?page=${payload.page}&filters=${payload.filters};`);

}

export const createEmployeeReq = (payload) => {
  return postFd(`${api}?`, payload);
}

export const getEmployeeByIdReq = (id) => {
  return get(`${api}/by-id/${id}`);
}
export const getEmploymentHistoryReq = (id) => {
  return get(`${api}/employment-history/${id}`);
}
export const getSalaryPolicyByEmpId = (id) => {
  return get(`${api}/salary-policy/${id}`);
}
export const updateSalaryPolicyReq = (payload) => {
  return post(`${api}/salary-policy/update/${payload.employmentId}`, payload);
}

export const updateEmployeeReq = (payload) => {
  return postFd("company/employees/employee_info?", payload);
}
export const uploadPhotoReq = (payload) => {
  return postFd(`${api}/upload-photo/${payload.employeeId}`, payload);
}
export const getEmploymentByIdReq = (payload) => {
  let filters = '';
  if (!payload.showActive && payload.showActive !== undefined) {
    filters = `${filters};trashed_type_|onlyTrashed`;
  } else {
    //remove trashed_type
    filters = filters.replace(/;trashed_type_\|onlyTrashed/, '');
  }
  return get(`company/employee/employments/${payload.id}?filters=${filters}`);
}
export const updateEmploymentReq = (payload) => {
  return postFd(`company/employee/employments/${payload.id}/update`, payload);
}
export const getUserByEmployeeIdReq = (id) => {
  return get(`company/users/get-by-employee/${id}`);
}
export const getContactByEmployeeIdReq = (id) => {
  return get(`employees/contacts/get-by-employee/${id}`);
}
export const updateUserReq = (payload) => {
  return post(`company/users/user_info?`, payload);
}
export const getProfileCardByEmploymentIdReq = (payload) => {
  let filters = '';
  if (!payload.showActive && payload.showActive !== undefined) {
    filters = `${filters};trashed_type_|onlyTrashed`;
  } else {
    //remove trashed_type
    filters = filters.replace(/;trashed_type_\|onlyTrashed/, '');
  }
  return get(`employee/employments/${payload.id}/profile-card?filters=${filters}`)
}
export const getAllTimeZonesReq = () => {
  return get(apiTimeZones)
};

export const getAllSalutationsReq = () => {
  return get(apiSalutations)
};
export const getCompanyReq = () => {
  return get('common/getCompany')
}

export const getAllGradesReq = () => {
  return get("common/getGrades")
};

export const getAllReligionsReq = () => {
  return get("common/getReligions")
};

export const getEmployeeRelatedDataReq = () => {
  return get("independent/employees/get-related-data")
}

export const getEmployeeUserRelatedDataReq = () => {
  return get("company/users/get-related-data")
}
export const getCompanyRelatedDataReq = () => {
  return get("employees/employee/employments/get-company-related-data/1")
}
export const getBranchsByLocationIdReq = (locationId) => {
  return get("common/getBranchsByLocationId/" + locationId)
}

export const matchCnicReq = (cnic) => {
  return get("independent/employees/by-cnic/" + cnic);
}
export const getFilterReq = (payload) => {
  let filters = '';
  if (!payload.showActive && payload.showActive !== undefined) {
    filters = `${filters};trashed_type_|onlyTrashed`;
  } else {
    //remove trashed_type
    filters = filters.replace(/;trashed_type_\|onlyTrashed/, '');
  }
  return get(`filters?${localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1}&fields=page=1&filters=supporting_fields_|is_line_manager,is_final_authority,is_hod,employees,grade,designation,gender,job_titles,employee_types,employment_types;organization_structure_fields_|location,branch,department;preset_|company_employee;${filters}`);
}

export const getSalaryByEmployeeIdReq = (id) => {
  return get(`company/salary/get-by-employee/${id}`);
}
export const updateSalaryReq = (payload) => {
  return post(`company/Salary/user_info?`, payload);
}

// export const getAllEmployeesReq = () => {
//   return get("company/employee/employments?page=1");
// };

export const getRelatedDataReq = () => {
  return get(`independent/employment/salaries/get-related-data?`)
}
export const getSalaryRelatedDataReq = (payload) => {
  return get(`company/employment/salaries/get-employment-related-data/${payload.employmentId}?&module_name=dashboard&action_name=index&predefined_employment_id=${payload.employmentId}&predefined_employee_id=${payload.employeeId}`, payload);
}
export const getSalaryHistoryReq = (payload) => {
  //   revision_history[requestable_class]: salary
  // revision_history[requestable_id]: 161  //this is the salary id
  return post(`revisionHistory/getHistory?`, payload);
}
export const getSalaryHistoriesReq = (payload) => {
  return get(`company/employment/salary_histories?page=1&filters=employee_|${payload.employmentId}`);
}

export const onDownloadSampleEmployeesReq = () => {
  return download(`company-employee/download-sample`);
}
export const importEmployeeDataReq = (payload) => {
  return postFd(`company/employees/import`, payload);
}
export const downloadEmpCardReq = (payload) => {
  return download(`employee/employments/download?page=1&filters=${payload.filters}`);
}

export const downloadReportReq = (payload) => {
  return download(`reports/download?page=${payload.page}&format=${payload.format}&filters=${payload.filters}&employment_id=${payload.employment_id}`)
}

//-----------Edit employee------------


//company / users / validate - username ? exclude_emp_id =

//get profile card
//https://demo-api.klok.ai/api/v1/employee/employments/94c5a64b-7ff7-40de-9f8f-9b01f1250c37/profile-card?

////download profile
//employee/employments/download?page=1&filters=download_type_|pdf;ids_|employmentId
